//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// eslint-disable-next-line import/extensions
import popMixin from '@/mixin/pop';
import lotteryMixin from '@/mixin/lottery';
export default {
  mixins: [popMixin, lotteryMixin],
  methods: {
    handle: function handle() {
      this.lottery({
        isClosePop: 1
      });
    }
  }
};